import type { CurrentUser } from "./auth";

// Зеркало server/src/config/pages.ts — списки ключей должны совпадать.
export const PAGE_KEYS = [
  "dashboard",
  "sites",
  "sweep",
  "compare",
  "markers",
  "renewals",
  "health",
  "events",
  "crawling",
  "tracking",
  "ads",
  "portfolio",
  "ai-visibility",
  "land-metrics",
  "reviews",
  "regs",
  "recycling",
  "offers",
  "offer-rates",
  "domains",
  "mailings",
  "finance",
  "cohorts",
  "users",
  "server",
  "logs",
  "backups",
  "analysis",
  "settings",
] as const;
export type PageKey = (typeof PAGE_KEYS)[number];

// Подписи для чекбоксов в редакторе роли (совпадают с пунктами меню).
export const PAGE_LABELS: Record<PageKey, string> = {
  dashboard: "Обзор",
  sites: "Сайты",
  sweep: "Сводная",
  compare: "Сравнение",
  markers: "Метки",
  renewals: "Продления доменов",
  health: "Здоровье",
  events: "События",
  crawling: "Краулинг",
  tracking: "Отслеживание",
  ads: "Реклама",
  portfolio: "Вердикты",
  "ai-visibility": "ИИ-видимость",
  "land-metrics": "Поведение на лендах",
  reviews: "Отзывы",
  regs: "Регистрации",
  recycling: "Ресайклинг",
  offers: "Офферы",
  "offer-rates": "Ставки офферов",
  domains: "Домены",
  mailings: "Рассылки",
  finance: "Финансы",
  cohorts: "Когорты брендов",
  users: "Пользователи",
  server: "Нагрузка",
  logs: "Логи",
  backups: "Бэкапы",
  analysis: "AI-аналитика",
  settings: "Настройки",
};

// Порядок = приоритет редиректа, совпадает с порядком меню.
export const PAGE_PATHS: { page: PageKey; path: string }[] = [
  { page: "dashboard", path: "/" },
  { page: "sites", path: "/sites" },
  { page: "sweep", path: "/sweep" },
  { page: "compare", path: "/compare" },
  { page: "markers", path: "/markers" },
  { page: "renewals", path: "/renewals" },
  { page: "health", path: "/health" },
  { page: "events", path: "/events" },
  { page: "crawling", path: "/crawling" },
  { page: "tracking", path: "/tracking" },
  { page: "ads", path: "/ads" },
  { page: "ai-visibility", path: "/ai-visibility" },
  { page: "land-metrics", path: "/land-metrics" },
  { page: "reviews", path: "/reviews" },
  { page: "regs", path: "/regs" },
  { page: "recycling", path: "/recycling" },
  { page: "offers", path: "/offers" },
  { page: "offer-rates", path: "/offers/rates" },
  { page: "domains", path: "/domains" },
  { page: "mailings", path: "/mailings" },
  { page: "finance", path: "/finance" },
  { page: "cohorts", path: "/finance/cohorts" },
  { page: "users", path: "/users" },
  { page: "server", path: "/server" },
  { page: "logs", path: "/logs" },
  { page: "backups", path: "/backups" },
  { page: "analysis", path: "/analysis" },
  { page: "portfolio", path: "/analysis/verdicts" },
  { page: "settings", path: "/settings" },
];

export function canSee(user: CurrentUser | undefined, page: PageKey): boolean {
  if (!user) return false;
  // pages ?? [] — страховка от старого /me без RBAC-полей (например, откат
  // сервера при открытой вкладке): деградируем в «нет доступа», не падаем.
  return user.isAdmin === true || (user.pages ?? []).includes(page);
}

export function firstAllowedPath(user: CurrentUser): string | null {
  const hit = PAGE_PATHS.find((p) => canSee(user, p.page));
  return hit?.path ?? null;
}
